import React from "react"
import Proptypes from "prop-types"
import locales from "../../../locales"

export const getResolvedLocale = i18n => {
  let currentLng

  for (let language of i18n.languages) {
    currentLng = locales.find(locale => locale.config.code === language)

    if (currentLng) {
      break
    }
  }

  return currentLng
}

export const getDataForLocale = (data, languageCode) => {
  const languages = [languageCode, "en"] // last language in array is default;
  const localize = value => {
    if (value === null) {
      return value
    }
    if (Array.isArray(value)) {
      return value.map(v => localize(v))
    } else if (typeof value == "object") {
      if (value._type && /^locale[A-Z]/.test(value._type)) {
        const language = languages.find(lang => value[lang])
        return value[language]
      }
      return Object.keys(value).reduce((result, key) => {
        result[key] = localize(value[key], languages)
        return result
      }, {})
    }
    return value
  }
  return localize(data)
}

export const isDefaultLng = lng => {
  return !!locales.find(
    locale => locale.config.code === lng && locale.config.isDefault
  )
}

export const localizeUrl = (t, { url } = {}) => {
  const parsedUrl = url === "/" ? "" : url
  return isDefaultLng(t("code", { ns: "config" }))
    ? `${parsedUrl}/`
    : `/${t("path", { ns: "config" })}${parsedUrl}/`
}
const createLocaleTextGetter = languageCode => {
  const languages = [languageCode, "en"] // last language in array is default;
  const localize = value => {
    if (value === null) {
      return value
    }
    if (Array.isArray(value)) {
      return value.map(v => localize(v))
    } else if (typeof value == "object") {
      if (value._type && /^locale[A-Z]/.test(value._type)) {
        const language = languages.find(lang => value[lang])
        return value[language]
      }
      return Object.keys(value).reduce((result, key) => {
        result[key] = localize(value[key], languages)
        return result
      }, {})
    }
    return value
  }
  return localize
}

export function localize(Component) {
  return class Localize extends React.Component {
    static propTypes = {
      data: Proptypes.object,
      pageContext: Proptypes.shape({
        locale: Proptypes.string,
      }),
    }
    constructor(props) {
      super(props)
      this.getLocalizedContent = createLocaleTextGetter(
        this.props.pageContext.locale
      )
    }
    render() {
      return (
        <Component
          {...this.props}
          data={this.getLocalizedContent(this.props.data)}
        />
      )
    }
  }
}
